<template>
<div class="chapter">
<div class="inner_page">
<p class="c2" id="calibre_pb_0">Smashwords Edition, License Notes</p>
<p class="c3">This book is licensed for your personal enjoyment
only. This ebook may not be resold or given away to other people.
If you would like to share this book with another person, please
purchase an additional copy for each recipient. If you’re reading
this book and did not purchase it, or it was not purchased for your
use only, then please return to your favorite ebook retailer and
purchase your own copy. Thank you for respecting the hard work of
this author.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_ca994ea13a81e463652c4b21610dab80_aZl3I6.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue?e44436e4